import { COUPON_STATUS } from "../enums/CouponStatus";

export const getDateFieldByStatus = (coupon) => {
  if (coupon?.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.redeemedDate;
  } else if (coupon?.status === COUPON_STATUS.ACTIVATED) {
    return coupon?.activationDate;
  } else if (coupon?.status === COUPON_STATUS.INACTIVE) {
    return coupon?.deactivationDate;
  }
  return coupon?.createdAt;
};

export const getRestaurantNameFieldByStatus = (coupon) => {
  if (coupon?.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.restaurant?.name;
  }
  return coupon?.restaurant?.name;
};

export const getRestaurantAddressFieldByStatus = (coupon) => {
  if (coupon?.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.restaurant?.address;
  }
  return coupon?.restaurant?.address;
};

export const getProductNameFieldByStatus = (coupon) => {
  if (coupon?.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.product?.name;
  }
  return coupon?.product?.name;
};

export const getProductPriceFieldByStatus = (coupon) => {
  if (coupon?.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.product?.price;
  }
  return coupon?.product?.price;
};

export const getProductDiscountFieldByStatus = (coupon) => {
  if (coupon.status === COUPON_STATUS.REDEEMED) {
    return coupon?.redeemedCoupon?.product?.discount;
  }
  return coupon?.product?.discount;
};
